import { createSlice } from '@reduxjs/toolkit';
import { handleGetProfile, handleLogin } from '~/thunks/auth/authThunk';
import { StorageEnum } from '~/utils/enum';
import { IProfile } from '~/utils/interface/auth';

export interface AuthState {
  accessToken: string | null | undefined;
  profile: IProfile;
}

const initialState: AuthState = {
  accessToken: localStorage.getItem(StorageEnum.ACCESS_TOKEN)! || null,
  profile: {},
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    handleLogout() {
      localStorage.removeItem(StorageEnum.ACCESS_TOKEN);
    },
  },
  extraReducers(builder) {
    builder.addCase(handleLogin.fulfilled, (_state, action) => {
      localStorage.setItem(StorageEnum.ACCESS_TOKEN, action.payload.token.access);
      localStorage.setItem(StorageEnum.REFRESH_TOKEN, action.payload.token.refresh);
      localStorage.setItem(StorageEnum.COMPANY_ID, action.payload.account.companyId ?? '');
    });

    builder.addCase(handleGetProfile.fulfilled, (state, action) => {
      state.profile = { ...action.payload };
      if (action.payload.permissions) {
        state.profile.permissions = { ...action.payload.permissions };
      }
    });
  },
});

export const authActions = authSlice.actions;

const authReducer = authSlice.reducer;
export default authReducer;
